/**
 * Общие типы для документов (documents) в Order и Product.
 * Соответствует filestorage.FileReference на backend.
 */

export interface DocumentFileReference {
  id: string;
  uri: string;
  filename: string;
  description?: string;
  size?: number;
  section: string;
}

export interface DocumentItemRequest {
  file: DocumentFileReference;
}

/** Преобразует UploadedFile в DocumentFileReference для API. */
export function toDocumentFileReference(
  file: { id: string; uri: string; filename?: string; size?: number },
  section: string,
): DocumentFileReference {
  return {
    id: file.id,
    uri: file.uri,
    filename: file.filename ?? '',
    description: '',
    size: file.size,
    section,
  };
}
